<template>
  <div class="filter-group">
    <div
      class="filter-group__header"
      :class="headerClass"
      @click="setVisibility"
    >
      <div class="filter-group__header-toggle">
        <slot name="title"></slot>
        <arrow-icon></arrow-icon>
      </div>
      <slot
        v-if="!isOpened && $nuxt.$breakpoints.sLg"
        name="chips"
      ></slot>
    </div>

    <div
      v-if="isVisuallyHidden"
      class="servers-configurator__filter-group-inner"
      :class="{'servers-configurator__filter-group-inner--visually-hidden' : isHiddenClass}"
    >
      <slot name="inner"></slot>
    </div>

    <div
      v-else
      v-show="setIsOpened"
      class="servers-configurator__filter-group-inner"
    >
      <slot name="inner"></slot>
    </div>
  </div>
</template>

<script>
import ArrowIcon from '~/assets/icons/common/arrow.svg'

export default {
  name: 'DedicatedConfigurationsFilterGroup',
  components: {
    ArrowIcon
  },
  props: {
    isVisuallyHidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpened: false,
      isHidden: true
    }
  },
  computed: {
    setIsOpened: {
      get() {
        return this.$nuxt.$breakpoints.sLg
          ? this.isOpened
          : true
      },
      set(value) {
        if (this.$nuxt.$breakpoints.sLg) {
          this.isOpened = value
        }
      }
    },
    isHiddenClass: {
      get() {
        return this.$nuxt.$breakpoints.sLg
          ? this.isHidden
          : false
      },
      set(value) {
        if (this.$nuxt.$breakpoints.sLg) {
          this.isHidden = value
        }
      }
    },
    headerClass() {
      return this.isOpened
        ? 'accordion__header--opened'
        : ''
    }
  },
  methods: {
    setVisibility() {
      if (this.$nuxt.$breakpoints.sLg) {
        this.isOpened = !this.isOpened
        this.isHidden = !this.isHidden
      }
    }
  }
}
</script>

<style lang="scss">
.filter-group {

  @media (max-width: $breakpoint-xl) {
    padding: 0 10px 12px;
    border-bottom: 1px solid rgba($primary, 0.1);
  }
}

.filter-group__header {
  position: relative;
  transition: color 0.2s;

  &--opened {
    svg {
      transform: rotate(180deg);
    }
  }

  svg {
    position: absolute;
    top: 22px;
    right: 0;
    display: none;
    transition: 0.3s ease-in-out;
    pointer-events: none;

    @media (max-width: $breakpoint-xl) {
      display: block;
    }
  }
}
</style>